import {isObjectEmpty} from "../../../../../../../../helpers/tools";
import {Input} from "../../../../../../../../components/ui/Input";
import React, {Fragment} from "react";
import {ListInformationElement} from "./ListInformationElement";

const MusCatEntry = ({data, changeHandler, musician_id}) => {
    if (isObjectEmpty(data)) return null

    const fields = (elem) => ([
        {
            title: elem.title,
            widthLimit: '3%'
        },
        {
            content: '',
            widthLimit: '40%',
            style: {paddingLeft:'10px'}
        },
        {
            content: <Input
                name={"client_cost"}
                value={elem.client_cost}
                type='text'
                id={"clientCost_"+elem.id}
                onChange={(val) => changeHandler("client_cost", val, musician_id, elem.id)}
            />,
            widthLimit: '27%',
            style: { margin: '0 auto', textAlign: 'center' }
        },
        {
            content: <Input
                name="estro_cost"
                value={elem.estro_cost}
                type='text'
                id={"estroCost_"+elem.id}
                onChange={(val) => changeHandler("estro_cost", val, musician_id, elem.id)}
            />,
            widthLimit: '27%',
            style: { margin: '0 auto', textAlign: 'center' }
        },
        {
            content: 'X',
            widthLimit: '3%'
        },
    ])

    return (<>
        {
            data.map((item, index) => (
                <Fragment key={"listInfoElem"+index}>
                    <ListInformationElement fields={fields(item)} />
                </Fragment>

            ))
        }
    </>)
}

export default MusCatEntry

